import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getATMData = createAsyncThunk("api/atm-payroll", async (token) => {
    try {
        const response = await nodeinstance.get("/atm-payroll", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const ATMDataSlice = createSlice({
    name: "boder",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getATMData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getATMData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getATMData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getATMData };
export default ATMDataSlice.reducer;
